export default "__VITE_ASSET__BBcBp7lM__"